module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remarks"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "select-tab",
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 0
      }
    }
  }, [_vm._v("文档")]), _vm._v(" "), _c('div', {
    staticClass: "select-tab",
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 1
      }
    }
  }, [_vm._v("评论")]), _vm._v(" "), _c('div', {
    staticClass: "select-tab",
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 2
      }
    }
  }, [_vm._v("日志")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    staticClass: "file"
  }, [_c('z-scrollDiv', {
    ref: "file",
    staticClass: "file-list-wrap",
    class: {
      all: !_vm.can_edit
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.require_files.length),
      expression: "require_files.length"
    }],
    staticClass: "top-text"
  }, [_vm._v("需求文档")]), _vm._v(" "), _c('transition-group', {
    ref: "requireList",
    staticClass: "file-list",
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.require_files), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "file-item"
    }, [_c('div', [_vm._v(_vm._s(item.doc_name))]), _vm._v(" "), _c('div', {
      staticClass: "func"
    }, [_c('span', {
      staticClass: "download"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.downloadFile(item.id)
        }
      }
    }, [_vm._v("下载")])])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.updated_at))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliver_files.length),
      expression: "deliver_files.length"
    }],
    staticClass: "top-text"
  }, [_vm._v("交付文档")]), _vm._v(" "), _c('transition-group', {
    staticClass: "file-list",
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.deliver_files), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "file-item"
    }, [_c('div', [_vm._v(_vm._s(item.doc_name))]), _vm._v(" "), _c('div', {
      staticClass: "func"
    }, [_c('span', {
      staticClass: "download"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.downloadFile(item.id)
        }
      }
    }, [_vm._v("下载")])])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.updated_at))])])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upload_doc.length),
      expression: "upload_doc.length"
    }],
    staticClass: "file-list",
    staticStyle: {
      "min-height": "55px"
    }
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("新添文档")]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "list"
    }
  }, _vm._l((_vm.upload_doc), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item"
    }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "func"
    }, [_c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeUpItem(index)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "btn-list"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.quitUpload()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.confirmUpload()
      }
    }
  }, [(_vm.docLoading) ? _c('span', {
    class: {
      'el-icon-loading': _vm.docLoading
    }
  }) : _c('span', [_vm._v("上传")])])])], 1)])], 1), _vm._v(" "), (_vm.can_edit) ? _c('div', {
    staticClass: "btn-bottom-func"
  }, [_c('div', {
    staticClass: "btn"
  }, [_c('input', {
    attrs: {
      "id": "doc",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.addUploadFile($event)
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$emit('openDoc')
      }
    }
  }, [_vm._m(1)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    staticClass: "comment"
  }, [_c('z-scrollDiv', {
    ref: "all-comment",
    staticClass: "all-comment",
    style: ({
      height: ("calc(100% - " + _vm.commentBottomH + "px)")
    })
  }, _vm._l((_vm.task_comment), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "comment-list"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('z-lazyImg', {
      staticClass: "userimg",
      attrs: {
        "src": item.user_logo
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.real_name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "comment-content"
    }, [_vm._v(_vm._s(item.log_content))]), _vm._v(" "), _c('p', {
      staticClass: "action"
    }, [(_vm.task_id == '0') ? _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.delComment(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("commentTime")(item.created_at)))])])])])
  })), _vm._v(" "), (_vm.can_edit) ? _c('div', {
    staticClass: "comment-input",
    on: {
      "mouseenter": function($event) {
        _vm.activeHover = true
      },
      "mouseleave": function($event) {
        _vm.activeHover = false
      }
    }
  }, [_c('div', {
    staticClass: "comment-fun"
  }, [_c('div', {
    staticClass: "area-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentText),
      expression: "commentText"
    }],
    staticClass: "pre",
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentText),
      expression: "commentText"
    }],
    ref: "comment-area",
    class: ['comment-text', {
      active: _vm.commentFlag
    }],
    style: ({
      height: _vm.commentInputH + 'px'
    }),
    attrs: {
      "type": "text",
      "placeholder": "添加评论"
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value
      }, function($event) {
        _vm.checkHeight('commentInputH', $event)
      }],
      "focus": function($event) {
        _vm.focusComment()
      },
      "blur": function($event) {
        _vm.blurComment()
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.subcomment($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "comment-btns",
    class: {
      active: _vm.commentFlag
    },
    on: {
      "click": function($event) {
        _vm.focusComment()
      }
    }
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.clearInput
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.subcomment
    }
  }, [(_vm.commentLoading) ? _c('span', {
    class: {
      'el-icon-loading': _vm.commentLoading
    }
  }) : _c('span', [_vm._v("发送")])])])])]) : _vm._e()], 1), _vm._v(" "), _c('z-scrollDiv', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 2),
      expression: "activeIndex == 2"
    }],
    staticClass: "log"
  }, _vm._l((_vm.task_log), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "log-item"
    }, [_c('div', {
      staticClass: "log-left overhide"
    }, [_c('span', {
      staticClass: "img"
    }), _vm._v(" "), _c('span', {
      staticClass: "member",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))])]), _vm._v(" "), _c('p', {
      staticClass: "log-right comment-content"
    }, [_vm._v("\n                    " + _vm._s(item.log_content.split("：")[0]) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("justDate")(item.updated_at)))])])
  }))], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("src/assets/image/upload.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("添加附件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("src/assets/image/download.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("文档模板下载")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4f84c634!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/detailTask/remark.vue
// module id = 743
// module chunks = 1